import classNames from 'classnames';
import { omit } from 'lodash-es';
import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';
import { Tooltip } from '../../tooltip';

type BadgeBaseProps = {
  srText?: string;
  className?: string;
};

const BadgeBase = forwardRef<HTMLDivElement, PropsWithChildren<BadgeBaseProps>>((props, ref) => (
  <div ref={ref} {...omit(props, 'children', 'srText', 'className')} className={classNames('flex items-center tds-badge-base', props.className)}>
    {props.children}
    <span className="sr-only">{props.srText}</span>
  </div>
));

type BadgeProps = BadgeBaseProps & {
  amount: number;
};

export const Badge = (props: BadgeProps) => <BadgeBase {...omit(props, 'amount', 'className')} className={classNames('tds-badge', props.className)}>{props.amount}</BadgeBase>;

type BadgeEmptyProps = {
  label?: string;
  className?: string;
};

export const BadgeEmpty = ({ className, label }: BadgeEmptyProps) => (
  <Tooltip content={label}>
    <BadgeBase className={classNames('tds-badge-empty', className)} srText={label} />
  </Tooltip>
);
